import { styled } from '@/stitches.config';
import Box from '../Box/Box';
import Label from '../Label/Label';
import { CSS } from '@stitches/react';
import { Variants } from '@common/types';

export const StyledContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
});

export const StyledTextContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  width: '100%',
});

export const labelStyles: CSS = {
  alignSelf: 'flex-start',
  fontWeight: '$medium',
};

export const StyledTextArea = styled('textarea', {
  border: '1px solid $darkGray500',
  borderRadius: '$4',
  color: '$charcoal300',
  fontSize: '$md',
  lineHeight: '$6',
  minHeight: '100px',
  padding: '$4',
  resize: 'none',
  width: '100%',

  '&::placeholder': {
    fontStyle: 'italic',
    fontWeight: '$regular',
  },
});

export const StyledCharCounter = styled('span', {
  color: '$darkGray300',
  fontSize: '$xs',
  fontWeight: '$medium',
  marginTop: '$4',
});

export const StyledSecondaryLabel = styled(Label, {
  display: 'inline-flex',
  fontWeight: '300',
  fontSize: '14px',
  marginLeft: '$1',
  textAlign: 'left',
  variants: {
    variant: {
      [Variants.PRIMARY]: {},
      [Variants.SECONDARY]: {
        fontWeight: '$bold',
        fontSize: '$normal',
        lineHeight: '$6',
        color: '$darkBlue400',
        marginRight: '$2',
      },
      [Variants.TERTIARY]: {},
    },
  },
});
